import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Search as Search23 } from 'projects/flow-gui-access/views/2.3/search'
import { Search as Search24 } from 'projects/flow-gui-access/views/2.4/search'

class Search extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.4').length !== 0) {
      return <Search24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.3').length !== 0) {
      return <Search23 {...this.props} />
    } else return false
  }
}
//eslint-disable-next-line
Search = connect(state => state)(Search)
export default Search



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/search/search.js